var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import s from './LineItems.scss';
import { Text } from 'wix-style-react';
import { currencyFormat } from '../../../core';
import { translate } from 'react-i18next';
import { Table } from './Table/Table';
import { HeaderLine } from './HeaderLine';
import { getTaxColumn } from './TaxColumn';
import { BodyCell } from './BodyCell';
var LineItems = function (_a) {
    var t = _a.t, lineItems = _a.lineItems, locale = _a.locale, currencyCode = _a.currencyCode, _b = _a.showTaxPerLineItem, showTaxPerLineItem = _b === void 0 ? false : _b, taxSettingsEnabled = _a.taxSettingsEnabled;
    var currency = currencyFormat({ locale: locale, currency: currencyCode });
    var customHeader = s.customizeHeader;
    var customCell = s.customizeCell;
    var customizePriceTitle = s.customizePriceTitle;
    var customQuantityTitle = s.customizeQuantityTitle;
    var customTotalTitle = s.customizeTotalTitle;
    var customPriceCell = s.customizePriceCell;
    if (taxSettingsEnabled) {
        return (React.createElement(GridTable, { formatCurrency: currency, lineItems: lineItems, showTaxPerLineItem: showTaxPerLineItem, t: t }));
    }
    return (React.createElement("table", { className: s.table },
        React.createElement("thead", { className: s.head },
            React.createElement("tr", null,
                React.createElement("th", { className: "".concat(s.header, " ").concat(customHeader) },
                    React.createElement(HeaderLine, { dataHook: "product-title" }, t('invoice-view:price-quote.view.line-items.product'))),
                React.createElement("th", { className: "".concat(s.header, " ").concat(customHeader, " ").concat(customizePriceTitle) },
                    React.createElement(HeaderLine, { dataHook: "price-title" }, t('invoice-view:price-quote.view.line-items.price'))),
                React.createElement("th", { className: "".concat(s.header, " ").concat(customHeader, " ").concat(customQuantityTitle) },
                    React.createElement(HeaderLine, { dataHook: "quantity-title" }, t('invoice-view:price-quote.view.line-items.quantity'))),
                showTaxPerLineItem ? (React.createElement("th", { className: "".concat(s.header, " ").concat(customHeader, " ").concat(s.customizeTaxTitle) },
                    React.createElement(HeaderLine, { dataHook: "tax-title" }, t('invoice-view:price-quote.view.line-items.tax')))) : null,
                React.createElement("th", { className: "".concat(s.header, " ").concat(customHeader, " ").concat(s.pullRight, " ").concat(customTotalTitle) },
                    React.createElement(HeaderLine, { dataHook: "total-title" }, t('invoice-view:price-quote.view.line-items.total'))))),
        React.createElement("tbody", null, lineItems.map(function (_a, index) {
            var name = _a.name, description = _a.description, price = _a.price, quantity = _a.quantity, total = _a.total, taxes = _a.taxes, taxedTotal = _a.taxedTotal;
            return [
                React.createElement("tr", { key: index },
                    React.createElement("td", { className: "".concat(s.cell, " ").concat(customCell) },
                        React.createElement("div", { className: s.productName },
                            React.createElement(BodyCell, { dataHook: "name-".concat(index) }, name)),
                        React.createElement("div", { className: s.description },
                            React.createElement("span", { className: s.spanForThaiPdf, "data-hook": "description-".concat(index) }, description))),
                    React.createElement("td", { className: "".concat(s.cell, " ").concat(customCell, " ").concat(customPriceCell) },
                        React.createElement(BodyCell, { dataHook: "price-".concat(index) }, currency(price))),
                    React.createElement("td", { className: "".concat(s.cell, " ").concat(customCell) },
                        React.createElement(BodyCell, { dataHook: "quantity-".concat(index) }, quantity)),
                    showTaxPerLineItem ? (React.createElement("td", { className: "".concat(s.cell, " ").concat(customCell, " ").concat(customizePriceTitle) }, taxes.map(function (tax, taxIndex) {
                        var _a;
                        return (React.createElement("div", { style: { display: 'block' }, key: taxIndex },
                            React.createElement(BodyCell, { dataHook: "tax-".concat(index, "-").concat(taxIndex) }, t('invoice-view:price-quote.view.totals.tax-rate', {
                                name: tax.name,
                                rate: (_a = tax.rate.serializedValue) !== null && _a !== void 0 ? _a : 0,
                            }))));
                    }))) : null,
                    React.createElement("td", { className: "".concat(s.cell, " ").concat(customCell, " ").concat(s.pullRight) },
                        React.createElement(BodyCell, { dataHook: "total-".concat(index) }, currency(showTaxPerLineItem ? taxedTotal : total)))),
                React.createElement("tr", { className: s.descriptionRow, key: "".concat(index, "A") },
                    React.createElement("td", { colSpan: 4 },
                        React.createElement("div", { className: s.descriptionCells },
                            React.createElement(Text, { dataHook: "description-row-".concat(index), secondary: true, light: true, size: "small" }, description)))),
                React.createElement("tr", { key: "".concat(index, "B") },
                    React.createElement("td", { colSpan: 12 },
                        React.createElement("hr", { className: s.divider }))),
            ];
        }))));
};
var GridTable = function (_a) {
    var t = _a.t, showTaxPerLineItem = _a.showTaxPerLineItem, currency = _a.formatCurrency, lineItems = _a.lineItems;
    return (React.createElement(Table, { columnGap: showTaxPerLineItem ? '12px' : '24px', columns: __spreadArray(__spreadArray([
            {
                header: (React.createElement(HeaderLine, { dataHook: "product-title" }, t('invoice-view:price-quote.view.line-items.product'))),
                value: function (item, index) { return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(BodyCell, { dataHook: "name-".concat(index), size: "small", weight: "normal" }, item.name),
                    React.createElement("span", { className: s.descriptionCell, "data-hook": "description-".concat(index) }, item.description))); },
                width: 'minmax(0, 1fr)',
            },
            {
                header: (React.createElement(HeaderLine, { dataHook: "quantity-title" }, t('invoice-view:price-quote.view.line-items.quantity'))),
                value: function (item, index) { return (React.createElement(BodyCell, { dataHook: "quantity-".concat(index) }, item.quantity)); },
                width: showTaxPerLineItem ? '109px' : '141px',
            },
            {
                header: (React.createElement(HeaderLine, { dataHook: "price-title" }, t('invoice-view:price-quote.view.line-items.price'))),
                value: function (item, index) { return (React.createElement(BodyCell, { dataHook: "price-".concat(index) }, currency(item.price))); },
                width: showTaxPerLineItem ? '109px' : '141px',
            }
        ], (showTaxPerLineItem ? [getTaxColumn({ t: t })] : []), true), [
            {
                header: (React.createElement(HeaderLine, { dataHook: "total-title" }, t('invoice-view:price-quote.view.line-items.total'))),
                value: function (item, index) { return (React.createElement(BodyCell, { dataHook: "total-".concat(index) }, currency(showTaxPerLineItem ? item.taxedTotal : item.total))); },
                width: showTaxPerLineItem ? '109px' : '141px',
                align: 'end',
            },
        ], false), items: lineItems }));
};
export default translate()(LineItems);
//# sourceMappingURL=LineItems.js.map